import { SampleType } from "@core/data";
import { SampleIndexQuery } from "../sample-index/sample-index.state-model";

export class InitSamplePicker {
    static readonly type = "[ImageMoveSamplePicker] Init";
    constructor(
        public orgKey: string,
        public sampleType: SampleType,
        public excludeSampleKey: string,
    ) {};
}

export class LoadSamplePicker {
    static readonly type = "[ImageMoveSamplePicker] Load";
    constructor() {};
}

export class QuerySamplePicker {
    static readonly type = "[ImageMoveSamplePicker] Query";
    constructor(public query: SampleIndexQuery) {}
}

export class PageSamplePicker {
    static readonly type = "[ImageMoveSamplePicker] Page";
    constructor(public index: number, public size: number) {};
}

export class SortSamplePicker {
    static readonly type = "[ImageMoveSamplePicker] Sort";
    constructor(public column: string, public order = 'asc') {}
}

export class ClearSamplePickerFilter {
    static readonly type = "[ImageMoveSamplePicker] Clear Filter";
    constructor() {}
}
